import React from 'react';
import './SignatureEvents.css';
import SEO from '../components/SEO';

const SignatureEvents = () => {
  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: window.innerWidth <= 768 ? '0 1rem' : '0 2rem'
  };

  return (
    <div className="signature-events-page">
      <SEO
        title="Signature Events"
        description="Join our community events, from Games Night to Innovation Hackathons. Connect, collaborate, and celebrate with YOCILAB."
      />
      {/* Hero Section */}
      <div className="events-hero-section">
        <div style={containerStyle}>
          <div className="events-section-header">
            <span className="events-section-label">SIGNATURE EVENTS</span>
          </div>
          <div className="events-hero-content">
            <div className="events-image-section">
              <div className="events-image-overlay-content">
                <h1 className="events-hero-title">
                  Connect.<br />
                  Collaborate. Celebrate.
                </h1>
                <button className="events-cta-button">Join Our Events</button>
              </div>
              <img
                src={require('../assets/YOCILAB/DSC_3053.jpg')}
                alt="YOCILAB community event"
                className="events-hero-image"
              />
            </div>
            <div className="events-content-section">
              <p className="events-main-description">
                Building community through meaningful connections and shared experiences.
              </p>
              <p className="events-detailed-description">
                Our signature events create spaces for young innovators to connect, collaborate,
                and showcase their work. From monthly game nights to innovation hackathons,
                each event is designed to strengthen our community while providing valuable
                opportunities for growth and networking.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Events Grid Section */}
      <div className="events-grid-section">
        <div style={containerStyle}>
          <div className="events-grid-header">
            <span className="section-label-small">OUR EVENTS</span>
            <h2 className="section-title">Join Our Community Events</h2>
            <p className="section-description">
              Regular gatherings that bring together innovators, entrepreneurs, and changemakers
            </p>
          </div>

          <div className="events-grid">
            {/* Games Night */}
            <div className="event-card">
              <div className="event-image">
                <img
                  src={require('../assets/YOCILAB/188427966_2939276489619955_7543274561038170662_n.jpg')}
                  alt="Games Night"
                />
                <div className="event-frequency">Monthly</div>
              </div>
              <div className="event-content">
                <h3 className="event-title">Games Night</h3>
                <p className="event-description">
                  Join us every last Saturday of the month for a fun, community-bonding evening
                  with board games, trivia, e-sports, and cultural exchanges. Builds relationships,
                  meet new people, and strengthens the YOCILAB community spirit.
                </p>
                <div className="event-details">
                  <div className="event-detail">
                    <span className="detail-label">When:</span>
                    <span className="detail-value">Last Saturday of every month</span>
                  </div>
                  <div className="event-detail">
                    <span className="detail-label">Activities:</span>
                    <span className="detail-value">Board games, trivia, e-sports, cultural exchanges</span>
                  </div>
                </div>
                <button className="event-cta-btn">Join Next Event</button>
              </div>
            </div>

            {/* Pitch Friday */}
            <div className="event-card">
              <div className="event-image">
                <img
                  src={require('../assets/YOCILAB/DSC_7451.jpg')}
                  alt="Pitch Friday"
                />
                <div className="event-frequency">Bi-Monthly</div>
              </div>
              <div className="event-content">
                <h3 className="event-title">Pitch Friday</h3>
                <p className="event-description">
                  A quarterly showcase where young innovators and entrepreneurs present their
                  projects to mentors, peers, and potential investors. It's an opportunity to
                  gain visibility, pitch for support, and build connections that take ideas
                  to the next stage.
                </p>
                <div className="event-details">
                  <div className="event-detail">
                    <span className="detail-label">When:</span>
                    <span className="detail-value">Every two months</span>
                  </div>
                  <div className="event-detail">
                    <span className="detail-label">Audience:</span>
                    <span className="detail-value">Mentors, peers, potential investors</span>
                  </div>
                </div>
                <button className="event-cta-btn">Submit Your Pitch</button>
              </div>
            </div>

            {/* Innovation Hackathon */}
            <div className="event-card">
              <div className="event-image">
                <img
                  src={require('../assets/YOCILAB/image_4494eb23-aa00-4436-9932-813623d55b4b20230127_122928 (1)_095109.jpg')}
                  alt="Innovation Hackathon"
                />
                <div className="event-frequency">Bi-Annual</div>
              </div>
              <div className="event-content">
                <h3 className="event-title">Innovation Hackathon</h3>
                <p className="event-description">
                  Every six months, we organize an intensive 48-hour sprint where young people
                  collaborate to solve real-world problems. Expect creativity, teamwork, and
                  breakthrough ideas with the potential to grow into real ventures. Top ideas
                  from the hackathon are incubated at YOCILAB.
                </p>
                <div className="event-details">
                  <div className="event-detail">
                    <span className="detail-label">Duration:</span>
                    <span className="detail-value">48-hour intensive sprint</span>
                  </div>
                  <div className="event-detail">
                    <span className="detail-label">Outcome:</span>
                    <span className="detail-value">Top ideas get incubated at YOCILAB</span>
                  </div>
                </div>
                <button className="event-cta-btn">Register Now</button>
              </div>
            </div>

            {/* Changemakers Forum */}
            <div className="event-card">
              <div className="event-image">
                <img
                  src={require('../assets/YOCILAB/afrikan Stars.jpg')}
                  alt="Changemakers Forum"
                />
                <div className="event-frequency">Biennial</div>
              </div>
              <div className="event-content">
                <h3 className="event-title">Changemakers Forum</h3>
                <p className="event-description">
                  A biennial gathering that brings together youth leaders, entrepreneurs, and
                  community builders to share stories, exchange ideas, and explore opportunities
                  for impact. The forum fosters cross-sector dialogue and inspires collective action.
                </p>
                <div className="event-details">
                  <div className="event-detail">
                    <span className="detail-label">Participants:</span>
                    <span className="detail-value">Youth leaders, entrepreneurs, community builders</span>
                  </div>
                  <div className="event-detail">
                    <span className="detail-label">Focus:</span>
                    <span className="detail-value">Cross-sector dialogue and collective action</span>
                  </div>
                </div>
                <button className="event-cta-btn">Learn More</button>
              </div>
            </div>

            {/* Green & Digital Jobs Fair */}
            <div className="event-card">
              <div className="event-image">
                <img
                  src={require('../assets/YOCILAB/Copy of youth.png')}
                  alt="Green & Digital Jobs Fair"
                />
                <div className="event-frequency">Annual</div>
              </div>
              <div className="event-content">
                <h3 className="event-title">Green & Digital Jobs Fair</h3>
                <p className="event-description">
                  An annual event connecting young people with career opportunities in the green
                  economy and digital sectors. Meet employers, explore job pathways, and gain
                  insights from industry leaders while networking with peers.
                </p>
                <div className="event-details">
                  <div className="event-detail">
                    <span className="detail-label">Focus Sectors:</span>
                    <span className="detail-value">Green economy and digital sectors</span>
                  </div>
                  <div className="event-detail">
                    <span className="detail-label">Opportunities:</span>
                    <span className="detail-value">Career paths, employer meetings, industry insights</span>
                  </div>
                </div>
                <button className="event-cta-btn">Explore Opportunities</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="events-cta-section">
        <div style={containerStyle}>
          <div className="cta-content">
            <h2 className="cta-title">Ready to Join Our Community?</h2>
            <p className="cta-description">
              Be part of a vibrant ecosystem where innovation meets impact.
              Connect with like-minded changemakers and grow your network.
            </p>
            <div className="cta-buttons">
              <button className="primary-cta-btn">View All Events</button>
              <button className="secondary-cta-btn">Join YOCILAB Community</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignatureEvents;